/* eslint-disable consistent-return */
import React from 'react';
import PropTypes from 'prop-types';
import {
  locationIcon,
  profileIcon,
  clockOrangeIcon,
} from 'assets/icons';
import styles from './ClassCardNewStyle.module.css';

const ClassCardNew = ({
  title,
  note,
  classDate,
  locationTitle,
  trainerName,
  cardStyles,
  classId,
  date,
  startTime,
  endTime,
  isVirtual,
  mobileCard,
  isHomePage,
  ...props
}) => {



  return (
    <div className={styles.classWrapper}>
      <>
        <p className={styles.title}>{title}</p>

        <div className={styles.itemWrapper}>
          <div className={styles.locationWrapper}>
            <img src={locationIcon} alt="Location icon" className={styles.locationIcon} />
            <p className={styles.locationName}>
              {mobileCard?.locationName}
              {!!mobileCard?.studioName && `, ${mobileCard?.studioName}`}
            </p>
          </div>

          <div className={styles.timeWrapper}>
            <img src={clockOrangeIcon} alt="Clock icon" className={styles.timeIcon} />
            <p className={styles.timeText}>
              {mobileCard?.time} {note && <span className={styles.note}>{note}</span>}
            </p>
          </div>
          <div className={styles.nameWrapper}>
            <img
              src={profileIcon}
              alt="Profile icon"
              className={styles.newProfileIcon}
            />
            <p className={styles.profileName}>{mobileCard?.trainer}</p>
          </div>
        </div>
     </>
    </div>
  );
};

ClassCardNew.propTypes = {
  title: PropTypes.string,
  note: PropTypes.string.isRequired,
  classDate: PropTypes.string,
  locationTitle: PropTypes.string,
  cardStyles: PropTypes.object,
  trainerName: PropTypes.string,
  isHomePage: PropTypes.bool,
  classId: PropTypes.number,
  date: PropTypes.string.isRequired,
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  isVirtual: PropTypes.bool.isRequired,
  mobileCard: PropTypes.object.isRequired,
};
ClassCardNew.defaultProps = {
  title: '',
  classDate: '',
  locationTitle: '',
  trainerName: '',
  cardStyles: {},
  classId: null,
  isHomePage: false,
};
export default ClassCardNew;
